import SectionHeading from "@/pages/home/components/SectionHeading";
import { editorPicks } from "@/mocks/home";

export default function EditorPicks() {
  return (
    <section id="picks" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="05"
          eyebrow="Editor Picks"
          title="编辑精选 · 榜单背后的方法"
          desc="除了条目本身，我们也解释榜单是怎么算的、截图该怎么核对。这部分内容不追热度，但能让你看得更清楚。"
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 md:gap-5">
          {editorPicks.map((pick) => (
            <article
              key={pick.title}
              className="flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="mb-3 flex items-center gap-2">
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
                  {pick.category}
                </span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-time-line text-sm" />
                  {pick.time}
                </span>
              </div>
              <h3 className="font-heading text-[16px] font-bold leading-snug text-foreground-950 md:text-[17px]">
                {pick.title}
              </h3>
              <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">
                {pick.summary}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-user-3-line text-xs text-secondary-700" />
                  </span>
                  {pick.author}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-book-open-line text-sm" />
                  阅读 {pick.read}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}